import { render, staticRenderFns } from "./AboutForm.vue?vue&type=template&id=fd796b2c&scoped=true&"
import script from "./AboutForm.vue?vue&type=script&lang=js&"
export * from "./AboutForm.vue?vue&type=script&lang=js&"
import style0 from "./AboutForm.vue?vue&type=style&index=0&id=fd796b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd796b2c",
  null
  
)

export default component.exports